"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.ToastEntity = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ToastEntity = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ToastEntity, _React$Component);

  var _super = _createSuper(ToastEntity);

  function ToastEntity() {
    var _this;

    (0, _classCallCheck2.default)(this, ToastEntity);
    _this = _super.apply(this, arguments);
    _this.timer = null;

    _this.startTimer = function () {
      var duration = _this.props.duration;

      if (duration === 0) {
        return;
      }

      _this.timer = setTimeout(function () {
        _this.handleClose();
      }, duration);
    };

    _this.clearTimer = function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
        _this.timer = null;
      }
    };

    _this.handleClose = function () {
      _this.clearTimer(); // eslint-disable-next-line


      _this.props.onClose && _this.props.onClose();
    };

    _this.renderHeader = function () {
      var _this$props = _this.props,
          title = _this$props.title,
          closable = _this$props.closable; // roo-theme 结构不合理，hack 一下

      var fixStyle = title ? {} : {
        width: 0,
        height: 0
      };
      return title || closable ? /*#__PURE__*/React.createElement("div", {
        className: "roo-toast-header",
        style: fixStyle
      }, closable ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "close",
        onClick: _this.handleClose
      }, /*#__PURE__*/React.createElement("span", {
        className: "roo-icon roo-icon-close"
      })) : null, title ? /*#__PURE__*/React.createElement("h5", {
        className: "title"
      }, title) : null) : null;
    };

    _this.renderBody = function () {
      var children = _this.props.children;
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-toast-body"
      }, /*#__PURE__*/React.createElement("span", {
        className: "content"
      }, children));
    };

    return _this;
  }

  (0, _createClass2.default)(ToastEntity, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _a = this.props,
          prefix = _a.prefix,
          title = _a.title,
          closable = _a.closable,
          status = _a.status,
          className = _a.className,
          theme = _a.theme,
          restProps = __rest(_a, ["prefix", "title", "closable", "status", "className", "theme"]);

      var toastCls = (0, _classnames.default)(prefix, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(prefix, "-tip"), !title), (0, _defineProperty2.default)(_classNames, "".concat(prefix, "-notice"), title), (0, _defineProperty2.default)(_classNames, "".concat(prefix, "-light"), theme === 'light'), _classNames), className);
      var contentCls = (0, _classnames.default)("".concat(prefix, "-content"), {
        'has-close': closable,
        'has-icon': status,
        'ani-spin': status === 'loading'
      }, status);
      return /*#__PURE__*/React.createElement("div", (0, _assign.default)({
        className: toastCls
      }, restProps), /*#__PURE__*/React.createElement("div", {
        className: contentCls
      }, this.renderHeader(), this.renderBody()));
    }
  }]);
  return ToastEntity;
}(React.Component);

exports.ToastEntity = ToastEntity;
ToastEntity.propTypes = {
  prefix: PropTypes.string,
  duration: PropTypes.number,
  onClose: PropTypes.func,
  closable: PropTypes.bool,
  status: PropTypes.string,
  theme: PropTypes.string,
  className: PropTypes.string
};
ToastEntity.defaultProps = {
  prefix: 'roo-toast',
  duration: 3000,
  onClose: function onClose() {},
  closable: false,
  status: undefined,
  theme: 'dark',
  className: undefined
}; // FIXME: 16.4 getDerivedStateFromProps 反模式，只能完全受控（组件使用变得很繁琐）

var _default = ToastEntity;
exports.default = _default;